const mapTable = [
  // BASIC INFO
  { to: "passport_type", from: ["Passport Type", "passport_type"] },
  { to: "nationality", from: ["Nationality", "nationality"] },
  { to: "port_of_arrival", from: ["Arrival Port", "Port of Arrival", "port_of_arrival", "arrival_port"] },
  { to: "date_of_birth", from: ["DOB", "Date of Birth", "date_of_birth", "dob"] },
  { to: "email_id", from: ["Email ID", "email_id", "present_email"] },
  { to: "expected_date_of_arrival", from: ["Expected Date of Arrival", "expected_date_of_arrival"] },

  // PERSONAL
  { to: "surname", from: ["Surname", "surname", "last_name"] },
  { to: "given_name", from: ["Given Name", "given_name", "first_name"] },
  { to: "name_change", from: ["Name Change", "name_change"] },
  { to: "gender", from: ["Gender", "gender"] },
  { to: "town_city_of_birth", from: ["Town/City of Birth", "town_city_of_birth", "place_of_birth_town"] },
  { to: "country_of_birth", from: ["Country of Birth", "country_of_birth"] },
  { to: "citizenship_national_id", from: ["Citizenship/National ID", "citizenship_national_id", "national_id"] },
  { to: "religion", from: ["Religion", "religion"] },
  { to: "visible_identification_marks", from: ["Visible Identification Marks", "visible_identification_marks"] },
  { to: "educational_qualification", from: ["Educational Qualification", "educational_qualification"] },
  { to: "nationality_acquisition", from: ["Nationality Acquisition", "nationality_acquisition"] },
  { to: "lived_2_years", from: ["Lived 2 Years", "Lived 2 Years in Current Country", "lived_2_years"] },

  { to: "father_name", from: ["Father Name", "father_name"] },
  { to: "father_nationality", from: ["Father Nationality", "father_nationality"] },
  { to: "father_prev_nationality", from: ["Father Previous Nationality", "father_prev_nationality"] },
  { to: "father_pob", from: ["Father Place of Birth", "father_pob"] },
  { to: "father_cob", from: ["Father Country of Birth", "father_cob"] },

  { to: "mother_name", from: ["Mother Name", "mother_name"] },
  { to: "mother_nationality", from: ["Mother Nationality", "mother_nationality"] },
  { to: "mother_prev_nationality", from: ["Mother Previous Nationality", "mother_prev_nationality"] },
  { to: "mother_pob", from: ["Mother Place of Birth", "mother_pob"] },
  { to: "mother_cob", from: ["Mother Country of Birth", "mother_cob"] },

  { to: "marital_status", from: ["Marital Status", "marital_status"] },

  // PASSPORT
  { to: "passport_number", from: ["Passport Number", "passport_number"] },
  { to: "passport_place_of_issue", from: ["Passport Place of Issue", "passport_place_of_issue"] },
  { to: "passport_date_of_issue", from: ["Passport Date of Issue", "passport_date_of_issue"] },
  { to: "passport_date_of_expiry", from: ["Passport Date of Expiry", "passport_date_of_expiry"] },
  { to: "other_passport", from: ["Have Other Passport?", "Other Passport?", "other_passport"] },
  { to: "other_passport_country", from: ["Other Passport Country", "other_passport_country"] },
  { to: "other_passport_no", from: ["Other Passport No", "other_passport_no"] },
  { to: "other_passport_doi", from: ["Other Passport Date of Issue", "Other Passport DOI", "other_passport_doi"] },
  { to: "other_passport_poi", from: ["Other Passport Place of Issue", "Other Passport POI", "other_passport_poi"] },
  { to: "other_passport_nationality", from: ["Other Passport Nationality", "other_passport_nationality"] },

  // PRESENT ADDRESS
  { to: "present_address_street", from: ["Present Address Street", "present_address_street", "present_street"] },
  { to: "present_address_city", from: ["Present Address City", "present_address_city", "present_city"] },
  { to: "present_address_state", from: ["Present Address State", "present_address_state", "present_state"] },
  { to: "present_address_zip", from: ["Present Address ZIP", "present_address_zip", "present_zip"] },
  { to: "present_address_country", from: ["Present Address Country", "present_address_country", "present_country"] },
  { to: "present_phone", from: ["Present Phone", "present_phone", "present_mobile"] },

  // PERMANENT ADDRESS
  { to: "same_address_checkbox", from: ["Same as Present Address", "Same Address Checkbox", "same_address_checkbox"] },
  { to: "permanent_street", from: ["Permanent Street", "permanent_street"] },
  { to: "permanent_city", from: ["Permanent City", "permanent_city"] },
  { to: "permanent_state", from: ["Permanent State", "permanent_state"] },

  // HERITAGE
  { to: "pak_heritage", from: ["Pak Heritage", "Pakistani Heritage", "pak_heritage"] },
  { to: "pak_heritage_details", from: ["Pak Heritage Details", "Pakistani Heritage Details", "pak_heritage_details"] },

  // VISA DETAILS
  { to: "places_to_visit", from: ["Places to Visit", "places_to_visit"] },
  { to: "hotel_booking", from: ["Hotel Booking", "hotel_booking"] },
  { to: "exit_port", from: ["Exit Port", "exit_port"] },

  // PREVIOUS INDIA VISIT
  { to: "visited_india_before", from: ["Visited India Before", "Visited India Before?", "visited_india_before"] },
  { to: "prev_stay_address", from: ["Prev Stay Address", "Previous Stay Address", "prev_stay_address"] },
  { to: "cities_visited", from: ["Cities Visited", "cities_visited"] },
  { to: "last_visa_no", from: ["Last Visa Number", "last_visa_no"] },
  { to: "last_visa_type", from: ["Last Visa Type", "last_visa_type"] },
  { to: "last_visa_poi", from: ["Last Visa POI", "Last Visa Place of Issue", "last_visa_poi"] },
  { to: "last_visa_doi", from: ["Last Visa DOI", "Last Visa Date of Issue", "last_visa_doi"] },
  { to: "permission_refused", from: ["Permission Refused", "Permission Refused Before?", "permission_refused"] },
  { to: "refusal_details", from: ["Refusal Details", "refusal_details"] },
  { to: "countries_visited_10_years", from: ["Countries Visited 10 Years", "Countries Visited (Last 10 Years)", "countries_visited_10_years"] },

  // SAARC
  { to: "saarc_visit", from: ["SAARC Visit", "SAARC Visit?", "saarc_visit"] },
  { to: "saarc_country", from: ["SAARC Country", "saarc_country"] },
  { to: "saarc_year", from: ["SAARC Year", "saarc_year"] },
  { to: "saarc_visits", from: ["SAARC Visits", "Number of SAARC Visits", "saarc_visits"] },

  // REFERENCES
  { to: "reference_india_name", from: ["Reference India Name", "Reference in India Name", "reference_india_name"] },
  { to: "reference_india_address", from: ["Reference India Address", "Reference in India Address", "reference_india_address"] },
  { to: "reference_india_phone", from: ["Reference India Phone", "Reference in India Phone", "reference_india_phone"] },
  { to: "reference_home_name", from: ["Reference Home Name", "reference_home_name"] },
  { to: "reference_home_address", from: ["Reference Home Address", "reference_home_address"] },
  { to: "reference_home_phone", from: ["Reference Home Phone", "reference_home_phone"] },

  // DECLARATION
  { to: "declaration", from: ["Declaration", "declaration"] },
];

// -----------------------------
// Normalizers
// -----------------------------
function normalizeYesNo(val) {
  if (val === undefined || val === null) return "";
  const v = String(val).trim().toLowerCase();
  if (["yes", "y", "true", "1"].includes(v)) return "Yes";
  if (["no", "n", "false", "0"].includes(v)) return "No";
  return "";
}

function normalizeGender(val) {
  if (!val) return "";
  const v = String(val).trim().toLowerCase();
  if (["male", "m"].includes(v)) return "Male";
  if (["female", "f"].includes(v)) return "Female";
  return "Other";
}

function normalizePassportType(val) {
  if (!val) return "";
  const v = String(val).trim().toLowerCase();
  if (v.includes("regular")) return "Regular";
  if (v.includes("official")) return "Official";
  if (v.includes("diplomatic")) return "Diplomatic";
  return "";
}

// Robust date normalizer → always return YYYY-MM-DD for <input type="date">
// IMPORTANT: Never construct a JS Date here (no timezone math!)
function normalizeDate(val) {
  if (!val) return "";

  let s = String(val).trim();

  // 1) Already pure date (safe)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

  // 2) ISO with time: keep only date part (safe, no parsing)
  const isoLead = s.match(/^(\d{4}-\d{2}-\d{2})[T\s]/);
  if (isoLead) return isoLead[1];

  // 3) yyyy.mm.dd or yyyy/mm/dd or yyyy-mm-dd (lenient separators, optional trailing dot)
  const ymd = s.match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})\.?$/);
  if (ymd) {
    const y = ymd[1];
    const m = String(ymd[2]).padStart(2, "0");
    const d = String(ymd[3]).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  // 4) dd[./-]mm[./-]yyyy → yyyy-mm-dd
  const dmy = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  if (dmy) {
    const dd = String(dmy[1]).padStart(2, "0");
    const mm = String(dmy[2]).padStart(2, "0");
    const yyyy = dmy[3];
    return `${yyyy}-${mm}-${dd}`;
  }

  // 5) 19 APR 1983 / 7 Nov 2011 / 7 Sept. 2011
  const monMap = {
    jan:"01", feb:"02", mar:"03", apr:"04", may:"05", jun:"06",
    jul:"07", aug:"08", sep:"09", sept:"09", oct:"10", nov:"11", dec:"12",
  };
  const dMonY = s.match(/^(\d{1,2})\s+([A-Za-z]{3,9})\.?,?\s+(\d{4})$/);
  if (dMonY) {
    const dd = String(dMonY[1]).padStart(2, "0");
    const monRaw = dMonY[2].toLowerCase().replace(/\./g, "");
    const monKey = monRaw === "sept" ? "sept" : monRaw.slice(0, 3);
    const mm = monMap[monKey];
    const yyyy = dMonY[3];
    if (mm) return `${yyyy}-${mm}-${dd}`;
  }

  // 6) Unknown format → return as-is (DON'T parse; avoid accidental tz shifts)
  return s;
}

// -----------------------------
// Main
// -----------------------------
export default function normalizeExtraction(raw) {
  const out = {};
  const src = raw || {};

  // 1) Base mapping
  for (const { to, from } of mapTable) {
    for (const key of from) {
      if (src[key] !== undefined && src[key] !== null && String(src[key]).trim() !== "") {
        out[to] = src[key];
        break;
      }
    }
  }

  // 2) Normalize select-type fields
  if (out.gender) out.gender = normalizeGender(out.gender);
  if (out.name_change) out.name_change = normalizeYesNo(out.name_change);
  if (out.lived_2_years) out.lived_2_years = normalizeYesNo(out.lived_2_years);
  if (out.pak_heritage) out.pak_heritage = normalizeYesNo(out.pak_heritage);
  if (out.visited_india_before) out.visited_india_before = normalizeYesNo(out.visited_india_before);
  if (out.permission_refused) out.permission_refused = normalizeYesNo(out.permission_refused);
  if (out.other_passport) out.other_passport = normalizeYesNo(out.other_passport);
  if (out.saarc_visit) out.saarc_visit = normalizeYesNo(out.saarc_visit);

  if (out.passport_type) out.passport_type = normalizePassportType(out.passport_type);

  // 3) Dates → YYYY-MM-DD so <input type="date"> shows them
  [
    "date_of_birth",
    "expected_date_of_arrival",
    "passport_date_of_issue",
    "passport_date_of_expiry",
    "other_passport_doi",
    "last_visa_doi",
  ].forEach((f) => {
    if (out[f]) out[f] = normalizeDate(out[f]);
  });

  // 4) Numbers
  if (out.saarc_visits !== undefined && out.saarc_visits !== null && out.saarc_visits !== "") {
    const num = parseInt(String(out.saarc_visits).replace(/\D/g, ""), 10);
    out.saarc_visits = Number.isFinite(num) ? num : "";
  }

  // 5) Keep any unmapped keys for debugging/visibility
  const knownTargets = new Set(mapTable.map((m) => m.to));
  out._extra = {};
  for (const k of Object.keys(src)) {
    const isMapped = mapTable.some((m) => Array.isArray(m.from) && m.from.includes(k));
    if (!isMapped && k !== "_extra") out._extra[k] = src[k];
  }

  return out;
}